/*
  Silvermine wishlist（sections/sm-wishlist-float.liquid 載入）。
  - 冇登入：存喺 localStorage（sm_wishlist），每件 {id, h}（h = product handle）。
  - 有登入而且設定咗 endpoint（大哥嘅 app proxy）：以帳戶為準；部機有嘢就 merge 上去再清走。
  - 心心掣：任何 [data-sm-wl] 元素（產品卡、產品頁），用 document 層 event delegation，
    LOAD MORE / filter 之後新加嘅卡都得。
  - Wishlist 頁：[data-sm-wl-page]，逐件用 /products/<handle>?sections=sm-wishlist-card 攞產品卡。
*/
(function () {
  if (window.smWishlist) return;

  var cfgEl = document.getElementById('sm-wl-config');
  var cfg = {};
  try { cfg = JSON.parse((cfgEl && cfgEl.textContent) || '{}'); } catch (e) { cfg = {}; }

  var KEY = 'sm_wishlist';
  var MAX = 100;
  var serverMode = !!(cfg.customer && cfg.endpoint);
  var items = [];

  function readLocal() {
    try {
      var v = JSON.parse(localStorage.getItem(KEY) || '[]');
      return Array.isArray(v) ? v.filter(function (x) { return x && x.id; }) : [];
    } catch (e) { return []; }
  }

  function writeLocal(list) {
    try { localStorage.setItem(KEY, JSON.stringify(list)); } catch (e) {}
  }

  function has(id) {
    id = String(id);
    for (var i = 0; i < items.length; i++) if (String(items[i].id) === id) return true;
    return false;
  }

  // 每件貨上次揀咗邊個款式（wishlist 頁預先揀好）：{productId: variantId}，淨係存喺部機
  var VKEY = 'sm_wl_variant';
  function variantPrefs() {
    try { var v = JSON.parse(localStorage.getItem(VKEY) || '{}'); return v && typeof v === 'object' ? v : {}; } catch (e) { return {}; }
  }
  function saveVariant(pid, vid) {
    if (!pid || !vid) return;
    var v = variantPrefs();
    v[pid] = String(vid);
    try { localStorage.setItem(VKEY, JSON.stringify(v)); } catch (e) {}
  }

  function handleFor(id) {
    var el = document.querySelector('[data-sm-wl="' + id + '"][data-handle]');
    return el ? el.getAttribute('data-handle') : '';
  }

  // 帳戶清單只回 id；handle 由 Liquid 俾嘅 server 清單或者頁面上嘅心心掣補返
  function fromIds(ids, known) {
    var map = {};
    (known || []).concat(items).forEach(function (x) { if (x && x.h) map[String(x.id)] = x.h; });
    return ids.map(function (id) { return { id: Number(id), h: map[String(id)] || handleFor(id) }; });
  }

  function render() {
    var n = items.length;
    document.querySelectorAll('[data-sm-wl]').forEach(function (b) {
      var on = has(b.getAttribute('data-sm-wl'));
      if (b.classList.contains('is-on') !== on) b.classList.toggle('is-on', on);
      var pressed = on ? 'true' : 'false';
      if (b.getAttribute('aria-pressed') !== pressed) b.setAttribute('aria-pressed', pressed);
      var label = on ? (cfg.t_remove || 'Remove from wishlist') : (cfg.t_add || 'Add to wishlist');
      if (b.getAttribute('aria-label') !== label) b.setAttribute('aria-label', label);
      // 字一樣就唔好寫，否則會觸發 MutationObserver 不停重畫
      var txt = b.querySelector('[data-sm-wl-text]');
      var t = on ? (cfg.t_saved || 'Saved to wishlist') : (cfg.t_add || 'Add to wishlist');
      if (txt && txt.textContent !== t) txt.textContent = t;
    });
    document.querySelectorAll('[data-sm-wl-count]').forEach(function (c) {
      var v = n > 99 ? '99+' : String(n);
      if (c.textContent !== v) c.textContent = v;
      if (c.hidden !== (n === 0)) c.hidden = n === 0;
    });
  }

  function save() {
    if (!serverMode) writeLocal(items);
    render();
    document.dispatchEvent(new CustomEvent('sm-wishlist:change', { detail: { items: items.slice() } }));
  }

  function callServer(action, ids) {
    return fetch(cfg.endpoint, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ action: action, ids: ids })
    }).then(function (r) {
      if (!r.ok) throw new Error('wishlist ' + r.status);
      return r.json();
    }).then(function (data) {
      if (data && Array.isArray(data.ids)) {
        items = fromIds(data.ids);
        save();
      }
    });
  }

  function toggle(id, handle) {
    id = Number(id);
    var on = has(id);
    if (on) {
      items = items.filter(function (x) { return String(x.id) !== String(id); });
    } else {
      if (items.length >= MAX) items.shift();
      items.push({ id: id, h: handle || handleFor(id) });
      // 喺產品頁加心心：記住而家揀緊嘅款式
      if (cfg.product && String(cfg.product.id) === String(id)) {
        var vin = document.querySelector('form[id^="product-form-"] [name="id"]');
        if (vin && vin.value) saveVariant(id, vin.value);
      }
    }
    save();
    if (serverMode) {
      callServer(on ? 'remove' : 'add', [id]).catch(function () {
        // 失敗就還原，唔好令畫面同帳戶唔一致
        if (on) items.push({ id: id, h: handle }); else items = items.filter(function (x) { return String(x.id) !== String(id); });
        save();
      });
    }
    return !on;
  }

  function init() {
    if (serverMode) {
      items = Array.isArray(cfg.server) ? cfg.server.slice() : [];
      var local = readLocal();
      var extra = local.filter(function (x) { return !has(x.id); });
      render();
      if (extra.length) {
        items = items.concat(extra);
        render();
        callServer('merge', extra.map(function (x) { return x.id; }))
          .then(function () { writeLocal([]); })
          .catch(function () {});
      } else if (local.length) {
        writeLocal([]);
      }
    } else {
      items = readLocal();
      render();
    }
  }

  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-sm-wl]');
    if (!b) return;
    e.preventDefault();
    e.stopPropagation();
    var nowOn = toggle(b.getAttribute('data-sm-wl'), b.getAttribute('data-handle'));
    b.classList.remove('is-pop');
    void b.offsetWidth;
    if (nowOn) {
      b.classList.add('is-pop');
      flyToFab(b);
    }
  }, true);

  // 收藏時：一個心心由撳嗰度飛落右下角個掣，個掣彈一下，件數閃出嚟一陣再收返（平時唔顯示件數）
  var flashTimer = null;
  function flashCount(target) {
    var holder = target.closest('[data-sm-fab]') || target;
    holder.classList.remove('is-flash');
    void holder.offsetWidth;
    holder.classList.add('is-flash');
    clearTimeout(flashTimer);
    flashTimer = setTimeout(function () { holder.classList.remove('is-flash'); }, 1800);
  }

  function flyToFab(from) {
    var target = document.querySelector('[data-sm-fab-toggle]') || document.querySelector('.sm-wl-float');
    if (!target || !target.getBoundingClientRect().width) return;
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var a = from.getBoundingClientRect();
    var t = target.getBoundingClientRect();
    if (reduce || !document.body.animate) { flashCount(target); return; }

    var fly = document.createElement('div');
    fly.className = 'sm-wl-fly';
    fly.innerHTML = cfg.icon || '';
    var size = 28;
    fly.style.left = (a.left + a.width / 2 - size / 2) + 'px';
    fly.style.top = (a.top + a.height / 2 - size / 2) + 'px';
    document.body.appendChild(fly);

    var dx = (t.left + t.width / 2) - (a.left + a.width / 2);
    var dy = (t.top + t.height / 2) - (a.top + a.height / 2);
    // 中途向上拱一拱，似拋落去
    var lift = Math.min(120, Math.max(40, Math.abs(dy) * 0.25));
    var anim = fly.animate([
      { transform: 'translate(0, 0) scale(1)', opacity: 1 },
      { transform: 'translate(' + dx * 0.45 + 'px, ' + (dy * 0.45 - lift) + 'px) scale(1.25)', opacity: 1, offset: 0.45 },
      { transform: 'translate(' + dx + 'px, ' + dy + 'px) scale(0.4)', opacity: 0.6 }
    ], { duration: 650, easing: 'cubic-bezier(.45,.05,.55,.95)' });
    anim.onfinish = function () {
      fly.remove();
      target.classList.remove('is-bump');
      void target.offsetWidth;
      target.classList.add('is-bump');
      flashCount(target);
    };
  }

  // LOAD MORE、filter、quick add 等等之後新出現嘅心心掣要同步狀態
  var pending = false;
  new MutationObserver(function () {
    if (pending) return;
    pending = true;
    requestAnimationFrame(function () { pending = false; render(); });
  }).observe(document.body, { childList: true, subtree: true });

  // 唔同分頁改咗 wishlist 都同步（只限部機模式）
  window.addEventListener('storage', function (e) {
    if (e.key === KEY && !serverMode) { items = readLocal(); render(); }
  });

  // 產品頁心心：位置由 SM Wishlist 設定揀（cfg.pdp_pos）
  //   'image'：產品圖左上角（放喺 media-gallery 入面，對住第一張圖）
  //   'title'：個名右邊（將 h1 同心心包喺同一行）
  function makeProductHeart(extraClass) {
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'sm-wl-heart ' + extraClass;
    btn.setAttribute('data-sm-wl', cfg.product.id);
    btn.setAttribute('data-handle', cfg.product.h);
    btn.innerHTML = cfg.icon || '';
    return btn;
  }

  function injectProductButton() {
    if (!cfg.product || document.querySelector('.sm-wl-heart--media, .sm-wl-heart--title')) return;

    if (cfg.pdp_pos !== 'title') {
      var gallery = document.querySelector('product-info media-gallery') || document.querySelector('media-gallery');
      if (gallery) {
        gallery.classList.add('sm-wl-has-heart');
        gallery.insertBefore(makeProductHeart('sm-wl-heart--media'), gallery.firstChild);
        render();
        return;
      }
    }

    var title = document.querySelector('product-info h1, .product__info-container h1, .product__title h1');
    if (!title) return;
    var row = document.createElement('div');
    row.className = 'sm-wl-titlerow';
    title.parentNode.insertBefore(row, title);
    // h1 本身有 margin-top，搬去成行度，心心先會同個名第一行對齊
    var mt = getComputedStyle(title).marginTop;
    row.style.marginTop = mt;
    title.style.marginTop = '0';
    row.appendChild(title);
    row.appendChild(makeProductHeart('sm-wl-heart--title'));
    render();
  }

  // Wishlist 頁
  function renderPage() {
    var page = document.querySelector('[data-sm-wl-page]');
    if (!page) return;
    var grid = page.querySelector('[data-sm-wl-grid]');
    var soldGrid = page.querySelector('[data-sm-wl-grid-soldout]');
    var empty = page.querySelector('[data-sm-wl-empty]');
    var loading = page.querySelector('[data-sm-wl-loading]');
    var list = items.slice().reverse();
    grid.innerHTML = '';
    if (soldGrid) soldGrid.innerHTML = '';
    empty.hidden = list.length > 0;
    if (!list.length) { if (loading) loading.hidden = true; return; }
    if (loading) loading.hidden = false;

    var jobs = list.map(function (x) {
      if (!x.h) return Promise.resolve(null);
      return fetch((cfg.root || '/') + 'products/' + encodeURIComponent(x.h) + '?sections=sm-wishlist-card', { credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (d) { return d && d['sm-wishlist-card'] ? { id: x.id, html: d['sm-wishlist-card'] } : { id: x.id, gone: true }; })
        .catch(function () { return null; });
    });

    Promise.all(jobs).then(function (res) {
      var gone = [];
      res.forEach(function (r) {
        if (!r) return;
        if (r.gone) { gone.push(r.id); return; }
        var tmp = document.createElement('div');
        tmp.innerHTML = r.html;
        var li = tmp.querySelector('li.grid__item');
        if (!li) { gone.push(r.id); return; }
        li.setAttribute('data-sm-wl-item', r.id);
        // 語言標籤搬去張圖下面：圖 + 標籤包做一欄（.sm-wl-media）
        var card = li.querySelector('.card');
        var inner = card && card.querySelector(':scope > .card__inner');
        if (inner) {
          var media = document.createElement('div');
          media.className = 'sm-wl-media';
          card.insertBefore(media, inner);
          media.appendChild(inner);
          var pill = card.querySelector(':scope > .card__content .badge--language');
          if (pill) media.appendChild(pill);
        }
        // PRE-ORDER / NEW / RESTOCK 標籤搬去成格卡嘅右上角（重複嘅用 CSS 收埋，只出第一個）
        li.querySelectorAll('.badge--preorder').forEach(function (bd) { li.appendChild(bd); });
        // 有款式揀：換走「Choose options」彈窗掣，直接喺度揀（預先揀返上次嗰款）
        var pick = tmp.querySelector('[data-sm-wl-pick]');
        var oldQa = li.querySelector('.quick-add');
        if (pick && oldQa) {
          var sel = pick.querySelector('select[name="id"]');
          var saved = variantPrefs()[r.id];
          if (sel && saved) {
            var opt = sel.querySelector('option[value="' + saved + '"]');
            if (opt && !opt.disabled) sel.value = saved;
          }
          pick.hidden = false;
          oldQa.parentNode.replaceChild(pick, oldQa);
        }
        // add to cart 變咗 icon，保留原本文字做 aria-label；旁邊顯示嘅字用句首大階（data-sm-wl-label）
        var qa = li.querySelector('.quick-add__submit');
        if (qa && !qa.getAttribute('aria-label')) {
          // 掣入面有隱藏嘅「sold out」字，淨係攞第一行
          var label = qa.textContent.trim().split(/\n/)[0].trim();
          qa.setAttribute('aria-label', label);
        }
        if (qa) {
          var shown = qa.getAttribute('aria-label') || '';
          qa.setAttribute('data-sm-wl-label', shown.charAt(0).toUpperCase() + shown.slice(1));
        }
        // 手機一行一件嘅「Remove」掣（電腦版用張圖嘅心心）
        var content = li.querySelector('.card > .card__content') || li.querySelector('.card__content');
        if (content) {
          var rm = document.createElement('button');
          rm.type = 'button';
          rm.className = 'sm-wl-remove';
          rm.setAttribute('data-sm-wl', r.id);
          rm.innerHTML = '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M4 7h16M9 7V4h6v3M6 7l1 13h10l1-13M10 11v6M14 11v6"/></svg><span>Remove</span>';
          content.appendChild(rm);
        }
        // 賣晒（notready 未開賣唔計）放去下面「Currently sold out」
        var soldOut = li.querySelector('.price--sold-out') && !li.querySelector('.button--coming-soon');
        (soldOut && soldGrid ? soldGrid : grid).appendChild(li);
      });
      // 落架 / 刪咗嘅產品自動清走
      if (gone.length) {
        items = items.filter(function (x) { return gone.indexOf(x.id) === -1; });
        save();
        if (serverMode) callServer('remove', gone).catch(function () {});
      }
      if (loading) loading.hidden = true;
      updatePageEmpty(page);
      render();
      document.dispatchEvent(new CustomEvent('sm-wishlist:page-ready'));
    });
  }

  function updatePageEmpty(page) {
    var grid = page.querySelector('[data-sm-wl-grid]');
    var soldGrid = page.querySelector('[data-sm-wl-grid-soldout]');
    var soldWrap = page.querySelector('[data-sm-wl-soldout]');
    var empty = page.querySelector('[data-sm-wl-empty]');
    var nSold = soldGrid ? soldGrid.children.length : 0;
    if (soldWrap) soldWrap.hidden = nSold === 0;
    var total = grid.children.length + nSold;
    if (empty) empty.hidden = total > 0;
    var t = page.querySelector('[data-sm-wl-total]');
    if (t) t.textContent = total ? total + (total === 1 ? ' item' : ' items') : '';
  }

  // 喺 wishlist 頁撳走心心：張卡淡出移除
  document.addEventListener('sm-wishlist:change', function () {
    var page = document.querySelector('[data-sm-wl-page]');
    if (!page) return;
    page.querySelectorAll('[data-sm-wl-item]').forEach(function (li) {
      if (!has(li.getAttribute('data-sm-wl-item'))) {
        li.classList.add('is-leaving');
        setTimeout(function () {
          li.remove();
          updatePageEmpty(page);
        }, 250);
      }
    });
  });

  // 合併掣：撳一下彈出 Wishlist / SILVERMINE Club
  var fab = document.querySelector('[data-sm-fab]');
  if (fab) {
    var fabToggle = fab.querySelector('[data-sm-fab-toggle]');
    var clubItem = fab.querySelector('[data-sm-club]');
    var joyTrigger = function () { return document.getElementById('Avada-Joy_FloatingButtonTrigger'); };
    var setOpen = function (open) {
      fab.classList.toggle('is-open', open);
      fabToggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      // Joy 未載入就收埋 Club，費事撳咗冇反應
      if (open && clubItem) clubItem.hidden = !joyTrigger();
    };
    // Club 視窗開住時主掣變「×」，撳一下就關 Club（Joy 個掣收埋咗，佢自己個 × 都仲用得）
    var joyWidget = function () { return document.querySelector('.Avada-Joy_ButtonWidget'); };
    var joyOpen = function () { var w = joyWidget(); return !!(w && w.classList.contains('opened')); };
    var watching = false;
    var watchJoy = function () {
      var w = joyWidget();
      if (!w || watching) return;
      watching = true;
      new MutationObserver(function () { fab.classList.toggle('is-joy', joyOpen()); })
        .observe(w, { attributes: true, attributeFilter: ['class'] });
    };
    fabToggle.addEventListener('click', function (e) {
      e.stopPropagation();
      if (joyOpen()) {
        var t = joyTrigger();
        if (t) t.click();
        return;
      }
      setOpen(!fab.classList.contains('is-open'));
    });
    if (clubItem) {
      clubItem.addEventListener('click', function (e) {
        e.stopPropagation();
        setOpen(false);
        var t = joyTrigger();
        if (t) {
          watchJoy();
          t.click();
          fab.classList.toggle('is-joy', joyOpen());
        }
      });
    }
    document.addEventListener('click', function (e) {
      if (fab.classList.contains('is-open') && !fab.contains(e.target)) setOpen(false);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && fab.classList.contains('is-open')) { setOpen(false); fabToggle.focus(); }
    });
  }

  // 手機 wishlist 頁：向左掃移除（拉過 35% 闊就移除，唔夠就彈返；上下碌頁唔受影響）
  (function () {
    var page = document.querySelector('[data-sm-wl-page]');
    if (!page || !window.matchMedia) return;
    var mq = window.matchMedia('(max-width: 749px)');
    var st = null;
    var setX = function (li, x) { li.style.setProperty('--sm-swipe', x + 'px'); };
    page.addEventListener('touchstart', function (e) {
      if (!mq.matches || e.touches.length !== 1) return;
      var li = e.target.closest('[data-sm-wl-item]');
      if (!li || e.target.closest('button, .quick-add')) return;
      st = { li: li, x: e.touches[0].clientX, y: e.touches[0].clientY, dx: 0, active: false };
    }, { passive: true });
    page.addEventListener('touchmove', function (e) {
      if (!st) return;
      var dx = e.touches[0].clientX - st.x;
      var dy = e.touches[0].clientY - st.y;
      if (!st.active) {
        if (dx < -10 && Math.abs(dx) > Math.abs(dy) * 1.5) {
          st.active = true;
          st.li.classList.add('is-swiping', 'is-dragging');
        } else if (Math.abs(dy) > 10 || dx > 10) {
          st = null;
          return;
        }
      }
      if (st.active) {
        st.dx = Math.min(0, dx);
        setX(st.li, st.dx);
      }
    }, { passive: true });
    var end = function () {
      if (!st) return;
      var s2 = st;
      st = null;
      if (!s2.active) return;
      var li = s2.li;
      li.classList.remove('is-dragging');
      if (-s2.dx > li.offsetWidth * 0.35) {
        try { localStorage.setItem('sm_wl_swiped', '1'); } catch (err) {}
        setX(li, -li.offsetWidth);
        setTimeout(function () { toggle(li.getAttribute('data-sm-wl-item')); }, 180);
      } else {
        setX(li, 0);
        setTimeout(function () { li.classList.remove('is-swiping'); }, 220);
      }
    };
    page.addEventListener('touchend', end);
    page.addEventListener('touchcancel', end);
    // 入頁示範：第一格自己向左探一下（現出紅色 Remove）再彈返；客人自己掃走過一次就唔再示範
    document.addEventListener('sm-wishlist:page-ready', function () {
      if (!mq.matches) return;
      try { if (localStorage.getItem('sm_wl_swiped')) return; } catch (err) { return; }
      var grid = page.querySelector('[data-sm-wl-grid]');
      var soldGrid = page.querySelector('[data-sm-wl-grid-soldout]');
      var li = (grid && grid.firstElementChild) || (soldGrid && soldGrid.firstElementChild);
      if (!li) return;
      setTimeout(function () {
        if (st) return;
        li.classList.add('is-swiping', 'is-peek');
        setX(li, -80);
        setTimeout(function () {
          setX(li, 0);
          setTimeout(function () { li.classList.remove('is-swiping', 'is-peek'); }, 500);
        }, 900);
      }, 700);
    });
    // 換款式：記住，下次入嚟預先揀返
    page.addEventListener('change', function (e) {
      var sel = e.target.closest('.sm-wl-pick__select');
      var li = sel && sel.closest('[data-sm-wl-item]');
      if (li) saveVariant(li.getAttribute('data-sm-wl-item'), sel.value);
    });
    // 掃完唔好當咗撳落去開產品頁
    page.addEventListener('click', function (e) {
      var li = e.target.closest('[data-sm-wl-item]');
      if (li && li.classList.contains('is-swiping')) { e.preventDefault(); e.stopPropagation(); }
    }, true);
  })();

  window.smWishlist = { items: function () { return items.slice(); }, toggle: toggle, has: has };

  init();
  injectProductButton();
  renderPage();
})();
